import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AppRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "retailer") return <Navigate to="/retailer" replace />;
  return <Navigate to="/wallet" replace />;
}
